export const styles = {
  shuffleBanner: {
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
    cursor: "pointer",
    height: "45px",
    width: "458px",
    gap: "20px",
    color: "events.textPrimary",
  },
  bodyText: {
    display: "flex",
    justifyContent: "start",
    alignItems: "start",
    flexDirection: "column",
    whiteSpace: "nowrap",
  },
  button: {
    height: "28px !important",
  },
};
